module.exports = __webpack_public_path__ + "img/78.4.NH3-N.1d78e848.png";